import { useEffect, useState } from "react";
import _ from "lodash";

import { Accordion, Alert, Button, Col, Form, Row } from "react-bootstrap";

import { daysFactor, fotoStapelKacheln, header, host } from "./globalVariables";
import DatePicker from "react-datepicker";

import { api } from "./pureFunctions";
import { parseOODateTime } from "./pureFunctions";
import { useConfig } from "./ConfigContext";
import { checkItem, debouncedSaveEstateData, getEstateData, renameDbxItem, saveEstateData } from "./networkFunctions";
import { SpinnerGroup } from "./Utils/SpinnerGroup";

export default function FotoManager({
   user,
   userlist,
   allKacheln,
   projektstufe,
   sendData,
   userObjects,
   basicdata,
   eskstatus,
   estateId,
   ownerData,
   dbxData,
   setDbxData,
}) {
   const config = useConfig();
   const [stapeldaten, setStapeldaten] = useState({
      mitMakler: false,
      terminStart: "",
      terminEnde: "",
      fotograf: "",
      flexibel: "",
      terminInfo: "",
   });
   const [selectedKacheln, setSelectedKacheln] = useState({ ft_innen: true, ft_aussen: true, ft_drohne: true });
   const [selectedTab, setSelectedTab] = useState("");
   const [newDbxFolderName, setNewDbxFolderName] = useState("");
   const [grafikFolder, setGrafikFolder] = useState("init");
   const [loading, setLoading] = useState();

   async function createFolderStructure(folderName) {
      const shootingFolder = config.dbx.rootFoto + folderName;
      await createFolder(config.dbx.rootHDR + folderName);
      await createFolder(config.dbx.rootHDR + folderName + "/01-RAW-Photos");
      await createFolder(shootingFolder);
      await createFolder(shootingFolder + "/Bilder");
      await createFolder(shootingFolder + "/360 Grad");
      await createFolder(shootingFolder + "/Für Grafik");
   }
   async function createFolder(folderName) {
      const res = await api.post("/api/dropbox/create-folder", { folderName }, header);
      console.log(res);

      //   if (!res.ok) throw new Error("Failed to create folder");
   }

   useEffect(() => {
      console.log(dbxData);

      /*  if (dbxData) {
         checkItem(config.dbx.rootGrafik + dbxData)
            .then((data) => {
               setGrafikFolder(dbxData);
            })
            .catch((err) => {
               setGrafikFolder("");

               console.log(err);
            });
         checkItem(config.dbx.rootFoto + dbxData)
            .then((data) => {})
            .catch((err) => {
               window.alert(
                  `Dropboxfehler!\n ${dbxData} existiert im ${config.dbx.rootFoto}-Ordner nicht.\nFalls verschoben oder umbenannt bitte zurück zu ${dbxData}`,
               );
            });
      } */
   }, [dbxData]);

   async function copyItem(oldFolderName) {
      try {
         await api.post("/api/dropbox/copy", { oldPath: config.dbx.rootFoto + oldFolderName }, header).then((data) => {
            console.log(data);
         });

         return oldFolderName;
      } catch (error) {
         window.alert(`Fehler beim Kopieren:\n${error}`);
         // return oldFolderName;
         setLoading("error");
      }
   }

   async function createAppointments(reqData) {
      await api
         .post("/api/createOOAppointment", reqData, header)
         .then((data) => {
            console.log(data);
            window.scrollTo(0, 0);
         })
         .catch((err) => {
            console.log(JSON.stringify(err.response.data, null, 1));
            /* setErrorMessage({
                        error: "onOffice",
                        message: JSON.stringify(err.response.data, null, 1),
                     }); */
         });
   }

   function generateFolderName() {
      return `${basicdata.objektnr_extern}_${basicdata.Name} ${basicdata.strasse} ${basicdata.plz} ${basicdata.ort}`;
   }

   return (
      <>
         <Alert variant="danger">
            <h2>
               Der gesamte Bereich <strong>Fotografie</strong> ist nur für das Fototeam!
            </h2>
            Hier müssen Makler nichts machen und Eskalationen werden auch vom Fototeam behandelt.
         </Alert>
         <Alert>
            <h2>Infos zur Terminierung</h2>
            <ul>
               <li>
                  <strong>Zustand</strong>: {basicdata.ind_3374_Feld_ObjIndividualCategoryFields314}
               </li>

               <li>
                  <strong>Kontaktperson</strong>: {basicdata.unp_knkt} {basicdata.unp_knktname} {basicdata.unp_knktnr}
               </li>
               <li>
                  <strong>Eigentümer kontaktieren ab</strong>:{" "}
                  {basicdata[config.estate.fotoTerminAb]
                     ? new Date(basicdata[config.estate.fotoTerminAb]).toLocaleDateString()
                     : ""}
               </li>
               <li>
                  <strong>Fototermin ab</strong>:{" "}
                  {basicdata.unp_ft_ab ? new Date(basicdata.unp_ft_ab).toLocaleDateString() : ""}
               </li>
            </ul>
            <strong>Besonderheiten</strong>:<br />
            {basicdata.unp_bes}
         </Alert>
         <Accordion className="mb-3" activeKey={"0"}>
            <Accordion.Item eventKey="0">
               <Accordion.Header>
                  <h2 className="ms-4">Fotomanager</h2>
               </Accordion.Header>
               <Accordion.Body>
                  <div
                     style={{
                        padding: "20px 28px",
                        border: "solid 1px #ddd",
                        boxShadow: "0 0 16px #bbb",
                        borderRadius: "8px",
                        marginTop: "16px",
                     }}
                  >
                     <Form>
                        <h5>
                           Dropbox-Ordner: <strong>{dbxData.name}</strong>
                        </h5>
                        {loading === "success" && <Alert variant="success">👍</Alert>}
                        {loading === "error" && <Alert variant="danger">Fehler!</Alert>}
                        <Row>
                           <Form.Group as={Col} controlId={"id_dbxOrdName"} className="mb-3">
                              <Form.Label>Neuer Dropbox-Ordnername</Form.Label>
                              <Form.Control
                                 onChange={(e) => {
                                    setNewDbxFolderName(e.target.value);
                                 }}
                                 value={newDbxFolderName}
                              ></Form.Control>
                           </Form.Group>
                        </Row>
                        <Row>
                           {dbxData?.name && !dbxData.grafik && (
                              <>
                                 <Col>
                                    <Form.Group controlId={"id_dbxOrdnerkopie"} className="mb-3">
                                       <Button
                                          className="w-100 h-100"
                                          disabled={loading}
                                          onClick={async () => {
                                             setLoading("loading");
                                             const newFolderName = await copyItem(dbxData.name);
                                             const grafikFolder = config.dbx.rootGrafik + newFolderName;
                                             await createFolder(grafikFolder + "/Ogulo Grundriss");
                                             await createFolder(grafikFolder + "/Expose_SRA3");
                                             setGrafikFolder(newFolderName);
                                             // await saveEstateData({ dbxData: { ...dbxData, grafik: true } }, estateId);

                                             setDbxData((prev) => ({ ...prev, grafik: true }));
                                             setLoading("success");
                                             setTimeout(() => {
                                                setLoading(false);
                                             }, 2000);
                                          }}
                                       >
                                          {loading === "loading" ? <SpinnerGroup /> : "Ordner für Grafik kopieren"}
                                       </Button>
                                    </Form.Group>
                                 </Col>
                              </>
                           )}
                           {dbxData?.name && (
                              <>
                                 <Col>
                                    <Form.Group controlId={"id_dbxOrdnererstellen"} className="mb-3">
                                       <Button
                                          className="w-100 h-100"
                                          disabled={
                                             loading || dbxData.name === (newDbxFolderName || generateFolderName())
                                          }
                                          onClick={async () => {
                                             setLoading("loading");

                                             try {
                                                const newFolderName = newDbxFolderName || generateFolderName();
                                                const fotoPath = config.dbx.rootFoto + dbxData.name;
                                                await checkItem(fotoPath);
                                                const fotoHDR = config.dbx.rootHDR + dbxData.name;
                                                await checkItem(fotoHDR);
                                                if (dbxData.grafik) {
                                                   const fotoGrafik = config.dbx.rootGrafik + dbxData.name;
                                                   await checkItem(fotoGrafik);
                                                }

                                                await renameDbxItem(
                                                   config.dbx.rootFoto + dbxData.name,
                                                   config.dbx.rootFoto + newFolderName,
                                                );
                                                await renameDbxItem(
                                                   config.dbx.rootHDR + dbxData.name,
                                                   config.dbx.rootHDR + newFolderName,
                                                );
                                                if (dbxData.grafik) {
                                                   await renameDbxItem(
                                                      config.dbx.rootHDR + dbxData.name,
                                                      config.dbx.rootHDR + newFolderName,
                                                   );
                                                }
                                                await saveEstateData(
                                                   { dbxData: { ...dbxData, name: newFolderName } },
                                                   estateId,
                                                );
                                                setDbxData((prev) => ({ ...prev, name: newFolderName }));
                                                setNewDbxFolderName("");
                                                setLoading("success");
                                             } catch (error) {
                                                setLoading("error");
                                                window.alert(
                                                   `Fehler!\nMöglicherweise wurde einer oder mehrere der Dropbox-Ordner verschoben oder woanders umbenannt.
                                                   Bitte zurück benennen zu: ${dbxData.name} \n\nFehlercode: ${error}`,
                                                );
                                             }

                                             setTimeout(() => {
                                                setLoading(false);
                                             }, 4000);
                                          }}
                                       >
                                          {loading === "loading" ? (
                                             <SpinnerGroup />
                                          ) : (
                                             <span>
                                                Ordner in <strong>{newDbxFolderName || generateFolderName()}</strong>{" "}
                                                umbenennen
                                             </span>
                                          )}
                                       </Button>
                                    </Form.Group>
                                 </Col>
                              </>
                           )}
                           {!dbxData?.name && (
                              <>
                                 <Col>
                                    <Form.Group controlId={"id_dbxOrdnererstellen"} className="mb-3">
                                       <Button
                                          className="w-100 h-100"
                                          disabled={loading}
                                          onClick={async () => {
                                             setLoading("loading");
                                             const newFolderName = newDbxFolderName || generateFolderName();
                                             console.log(newFolderName);

                                             await createFolderStructure(newFolderName);
                                             await saveEstateData(
                                                { dbxData: { name: newFolderName, hdr: true, foto: true } },
                                                estateId,
                                             );
                                             setDbxData({ name: newFolderName, hdr: true, foto: true });
                                             setLoading("success");
                                             setTimeout(() => {
                                                setLoading(false);
                                             }, 2000);
                                          }}
                                       >
                                          {loading === "loading" ? (
                                             <SpinnerGroup />
                                          ) : (
                                             <span>
                                                <strong>{newDbxFolderName || generateFolderName()}</strong> Ordner
                                                initialisieren
                                             </span>
                                          )}
                                       </Button>
                                    </Form.Group>
                                 </Col>
                                 <Col>
                                    <Form.Group controlId={"id_dbxOrdnererstellen"} className="mb-3">
                                       <Button
                                          disabled={!newDbxFolderName}
                                          className="w-100 h-100"
                                          onClick={async () => {
                                             await saveEstateData(
                                                { dbxData: { name: newDbxFolderName, hdr: true, foto: true } },
                                                estateId,
                                             );
                                             setDbxData({ name: newDbxFolderName, hdr: true, foto: true });
                                          }}
                                       >
                                          Vorhandenen Ordner <strong>{newDbxFolderName}</strong> verlinken
                                       </Button>
                                    </Form.Group>
                                 </Col>
                              </>
                           )}
                        </Row>
                     </Form>
                     <Form>
                        <Row>
                           <h4>Auswahl der Dienstleistung</h4>
                           <Form.Group as={Col} controlId={"dienstleistung"} className="mb-3">
                              <div className="multi-select flex-row">
                                 {allKacheln &&
                                    Object.keys(fotoStapelKacheln).map((item) => {
                                       let mykachel;
                                       if (allKacheln[projektstufe].kachel.length) {
                                          mykachel = allKacheln[projektstufe].kachel.find(
                                             (kachelitem) => kachelitem.kachelId === item,
                                          );
                                       }

                                       if (mykachel) {
                                          return (
                                             <div
                                                key={"stapelkachel_" + item}
                                                title={mykachel.heading}
                                                className={
                                                   "multi-select-option" +
                                                   (selectedKacheln[item] ? " multi-selected" : "")
                                                }
                                                onClick={() => {
                                                   console.log(selectedKacheln);

                                                   setSelectedKacheln((prev) => {
                                                      const { [item]: deleteKey, ...rest } = prev;
                                                      return prev[item]
                                                         ? rest
                                                         : { ...prev, [item]: fotoStapelKacheln[item] };
                                                   });
                                                }}
                                             >
                                                {mykachel.heading}
                                             </div>
                                          );
                                       }
                                    })}
                              </div>
                           </Form.Group>
                        </Row>
                     </Form>
                     {Object.keys(selectedKacheln).length > 0 && (
                        <>
                           <ul className="nav nav-tabs nav-fill justify-content-center mb-4">
                              {["Terminerstellung", "Abschließen"].map((projektstufe_key, index) => (
                                 <li className="nav-item" key={projektstufe_key}>
                                    <button
                                       style={{
                                          height: "60px",
                                          marginBottom: "-1px",
                                       }}
                                       className={"nav-link" + (projektstufe_key === selectedTab ? " active" : "")}
                                       name={projektstufe_key}
                                       aria-current="page"
                                       onClick={(e) => {
                                          console.log(e.target.name);
                                          setSelectedTab(e.target.name);
                                       }}
                                    >
                                       {projektstufe_key}
                                    </button>
                                 </li>
                              ))}
                           </ul>
                           {selectedTab === "Terminerstellung" && (
                              <Form>
                                 <Row>
                                    <h4>Neuen Termin für ausgewählte Leistungen erstellen</h4>
                                    <div className="col" style={{ position: "relative" }}>
                                       <Form.Group as={Col} controlId={"id_am"} className="mb-3">
                                          <Form.Label>Terminstart</Form.Label>

                                          <DatePicker
                                             selected={
                                                stapeldaten.terminStart ? new Date(stapeldaten.terminStart) : false
                                             }
                                             showTimeSelect
                                             timeIntervals={5}
                                             onChange={(e) => {
                                                let newStapelDaten = structuredClone(stapeldaten);
                                                newStapelDaten.terminStart = e;
                                                if (
                                                   !newStapelDaten.terminEnde ||
                                                   newStapelDaten.terminEnde < newStapelDaten.terminStart
                                                ) {
                                                   newStapelDaten.terminEnde = e;
                                                }
                                                setStapeldaten(newStapelDaten);
                                             }}
                                             className={"bootstrap-datepicker"}
                                             calendarClassName="custom-date-calendar"
                                             timeFormat="HH:mm"
                                             dateFormat="dd.MM.yyyy, HH:mm"
                                             popperPlacement="bottom"
                                             locale="de"
                                          />
                                       </Form.Group>
                                       <button
                                          type="button"
                                          title="heute und jetzt als Datum einstellen"
                                          className="now-button"
                                          onClick={(e) => {
                                             setStapeldaten((prev) => ({
                                                ...prev,
                                                terminStart: new Date(),
                                             }));
                                          }}
                                       >
                                          {"˅"}
                                       </button>{" "}
                                    </div>
                                    <div className="col" style={{ position: "relative" }}>
                                       <Form.Group as={Col} controlId={"id_am"} className="mb-3">
                                          <Form.Label>Terminende</Form.Label>

                                          <DatePicker
                                             selected={
                                                stapeldaten.terminEnde ? new Date(stapeldaten.terminEnde) : false
                                             }
                                             showTimeSelect
                                             timeIntervals={5}
                                             onChange={(e) => {
                                                let newStapelDaten = structuredClone(stapeldaten);
                                                setStapeldaten((prev) => ({
                                                   ...prev,
                                                   terminEnde: e,
                                                }));
                                             }}
                                             minDate={
                                                stapeldaten.terminStart ? new Date(stapeldaten.terminStart) : new Date()
                                             }
                                             className={"bootstrap-datepicker"}
                                             calendarClassName="custom-date-calendar"
                                             timeFormat="HH:mm"
                                             dateFormat="dd.MM.yyyy, HH:mm"
                                             popperPlacement="bottom"
                                             locale="de"
                                          />
                                       </Form.Group>
                                       <button
                                          type="button"
                                          title="heute und jetzt als Datum einstellen"
                                          className="now-button"
                                          onClick={(e) => {
                                             setStapeldaten((prev) => ({
                                                ...prev,
                                                terminEnde: new Date(),
                                             }));
                                          }}
                                       >
                                          {"˅"}
                                       </button>{" "}
                                    </div>
                                 </Row>
                                 <Row className="mb-3">
                                    <Form.Group as={Col} controlId={"fotograf"} className="mb-3">
                                       <Form.Label>Fotograf</Form.Label>

                                       <Form.Select
                                          onChange={(e) =>
                                             setStapeldaten((prev) => ({
                                                ...prev,
                                                [e.target.name]: e.target.value,
                                             }))
                                          }
                                          name="fotograf"
                                          value={stapeldaten.fotograf ? stapeldaten.fotograf : ""}
                                       >
                                          <option value=""></option>
                                          <option value={user.id}>
                                             {user.Vorname} {user.Nachname}
                                          </option>
                                          {userlist &&
                                             userlist.map((user, index) => (
                                                <option key={"selectuser_" + user.Name} value={user.id}>
                                                   {user.Nachname + " " + user.Vorname}
                                                </option>
                                             ))}
                                       </Form.Select>
                                    </Form.Group>
                                    <Form.Group as={Col} controlId={"id_von"} className="mb-3">
                                       <Form.Label>mit Makler</Form.Label>

                                       <Form.Select
                                          onChange={(e) =>
                                             setStapeldaten((prev) => ({
                                                ...prev,
                                                [e.target.name]: e.target.value,
                                             }))
                                          }
                                          name="mitMakler"
                                          value={stapeldaten.mitMakler}
                                       >
                                          <option value={""}></option>
                                          <option value={"Ja"}>Ja</option>
                                          <option value={"Nein"}>Nein</option>
                                       </Form.Select>
                                    </Form.Group>
                                    <Form.Group as={Col} controlId={"id_von"} className="mb-3">
                                       <Form.Label>flexibel</Form.Label>
                                       <Form.Select
                                          onChange={(e) =>
                                             setStapeldaten((prev) => ({
                                                ...prev,
                                                [e.target.name]: e.target.value,
                                             }))
                                          }
                                          name="flexibel"
                                          value={stapeldaten.flexibel}
                                       >
                                          <option value={""}></option>
                                          <option value={"Ja"}>Ja</option>
                                          <option value={"Nein"}>Nein</option>
                                       </Form.Select>
                                    </Form.Group>
                                 </Row>
                                 <Row>
                                    <Form.Group as={Col} controlId={"id_von"} className="mb-3">
                                       <Form.Label>Bemerkung (Name Kontaktperson, usw.)</Form.Label>
                                       <Form.Control
                                          style={{ minHeight: "115px", fieldSizing: "content" }}
                                          as="textarea"
                                          onChange={(e) =>
                                             setStapeldaten((prev) => ({
                                                ...prev,
                                                [e.target.name]: e.target.value,
                                             }))
                                          }
                                          name="terminInfo"
                                          value={stapeldaten.terminInfo}
                                       ></Form.Control>
                                    </Form.Group>
                                 </Row>
                                 <Row className="mb-3">
                                    <Form.Group>
                                       {Object.values(stapeldaten).some((item) => !item) && (
                                          <span style={{ color: "#c00", fontWeight: 700 }}>
                                             Bitte alle Felder ausfüllen
                                          </span>
                                       )}
                                       <Button
                                          disabled={Object.keys(stapeldaten)
                                             .filter((item) => item != "terminInfo")
                                             .some((item) => !stapeldaten[item])}
                                          className="w-100 p-4"
                                          onClick={() => {
                                             let newEskStatus = structuredClone(eskstatus);
                                             let newBasicData = structuredClone(basicdata);
                                             let leistungsstring = "";
                                             Object.keys(selectedKacheln).forEach((iteKachelId) => {
                                                if (iteKachelId === "ft_reel") {
                                                   newEskStatus["kachel_eskalation_" + iteKachelId] = new Date(
                                                      stapeldaten.terminStart.getTime() + daysFactor * 7.5,
                                                   );
                                                } else {
                                                   newEskStatus["kachel_eskalation_" + iteKachelId] = new Date(
                                                      stapeldaten.terminStart.getTime() + daysFactor * 1.5,
                                                   );

                                                   if (iteKachelId === "ft_innen") {
                                                      newEskStatus["kachel_eskalation_expo_text"] = new Date(
                                                         stapeldaten.terminStart.getTime() + daysFactor * 1.5,
                                                      );
                                                   }
                                                }
                                                newBasicData[config.estate.fotograf] = stapeldaten.fotograf;
                                                newBasicData[selectedKacheln[iteKachelId] + "_st"] = "beauftragt";
                                                newBasicData[selectedKacheln[iteKachelId] + "_dat"] = new Date(
                                                   stapeldaten.terminStart,
                                                );
                                                newEskStatus["kachel_status_" + iteKachelId] = 1;
                                                leistungsstring += iteKachelId.slice(3) + " ";
                                             });

                                             newEskStatus["kachel_status_expo_bilder_erstellen"] = 4;
                                             newEskStatus["kachel_status_ft_abgabe"] = 1;
                                             newEskStatus["kachel_eskalation_ft_abgabe"] = new Date(
                                                stapeldaten.terminStart.getTime() + daysFactor * 1.5,
                                             );

                                             if (!newBasicData.ind_3266_Feld_ObjTech307) {
                                                newBasicData.ind_3266_Feld_ObjTech307 = stapeldaten.terminStart;
                                             }
                                             console.log(ownerData.ownerid);

                                             let fotoNotiz = `
${stapeldaten.terminInfo}
Fotograf: ${userObjects[stapeldaten.fotograf].Name}
${stapeldaten.mitMakler === "Ja" ? "Mit Makler" : "Ohne Makler"}
Leistungen: ${leistungsstring}
flexibel: ${stapeldaten.flexibel}
terminiert von ${user.Name} um ${new Date().toLocaleString()}`;
                                             newBasicData.ft_termin =
                                                fotoNotiz +
                                                (newBasicData.ft_termin
                                                   ? `+++++++++++++++
`
                                                   : "") +
                                                newBasicData.ft_termin;
                                             /*  newBasicData.ft_termin =
                                                `Am: ${stapeldaten.terminStart.toLocaleString()}
mit Fotograf: ${userObjects[stapeldaten.fotograf].Name}
${stapeldaten.mitMakler === "Ja" ? " mit Makler" : " ohne Makler"}
Leistungen: ${leistungsstring}
flexibel: ${stapeldaten.flexibel}
terminiert von ${user.Name} um ${new Date().toLocaleString()}
` +
                                                (newBasicData.ft_termin
                                                   ? `-----------------------------
`
                                                   : "") +
                                                newBasicData.ft_termin; */
                                             console.log(userObjects);
                                             console.log(stapeldaten.fotograf);
                                             console.log(estateId);

                                             createAppointments({
                                                data: {
                                                   description: "FT: " + leistungsstring,
                                                   start_dt: parseOODateTime(stapeldaten.terminStart),
                                                   end_dt: parseOODateTime(stapeldaten.terminEnde),
                                                   art: "Fototermin",
                                                   ganztags: false,
                                                   von: user.Name,
                                                   note: fotoNotiz,

                                                   private: false,
                                                },
                                                relatedAddressIds: ownerData.ownerid ? [ownerData.ownerid] : [],
                                                relatedEstateId: estateId,
                                                location: {
                                                   estate: estateId,
                                                },
                                                subscribers: {
                                                   users:
                                                      stapeldaten.mitMakler === "Ja"
                                                         ? [basicdata.benutzer, stapeldaten.fotograf]
                                                         : [stapeldaten.fotograf],
                                                },
                                             });

                                             sendData({ postEskData: newEskStatus, postData: newBasicData });
                                          }}
                                       >
                                          Termin in Kalender{" "}
                                          {stapeldaten.fotograf ? "von " + userObjects[stapeldaten.fotograf].Name : ""}{" "}
                                          {stapeldaten.mitMakler === "Ja" && userObjects
                                             ? " und " + userObjects[basicdata.benutzer].Name
                                             : ""}{" "}
                                          schreiben
                                       </Button>
                                    </Form.Group>
                                 </Row>
                              </Form>
                           )}

                           {selectedTab === "Abschließen" && (
                              <Form>
                                 <Row>
                                    <h4 className="mt-3">Ausgewählte Leistungen abschließen</h4>
                                    <Form.Group>
                                       <Button
                                          onClick={() => {
                                             let newEskStatus = structuredClone(eskstatus);
                                             let newBasicData = structuredClone(basicdata);
                                             Object.keys(selectedKacheln).forEach((iteKachelId) => {
                                                newEskStatus["kachel_status_" + iteKachelId] = 4;
                                                newBasicData[selectedKacheln[iteKachelId] + "_st"] = "abgeschlossen";
                                             });

                                             console.log(newEskStatus);
                                             sendData({ postEskData: newEskStatus, postData: newBasicData });
                                          }}
                                          className="w-100 btn-dark"
                                          style={{ background: "#090", borderColor: "#090" }}
                                       >
                                          {" "}
                                          Abschließen
                                       </Button>
                                    </Form.Group>
                                 </Row>
                              </Form>
                           )}
                        </>
                     )}
                  </div>
               </Accordion.Body>
            </Accordion.Item>
         </Accordion>
      </>
   );
}
